import React, { Component } from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens
import {
  DigitalSkillsTrainingHome,
  DigitalSkillsTrainingRegistrationForm,
} from "../screens/subscriber/digitalskillstraining";

const DigitalSkillsTraining = () => {
  const match = useRouteMatch();
  return (
    <>
      <Desktop phonebg={"white"}>
        <Switch>
          <Route
            path={`${match.path}/register`}
            render={() => <DigitalSkillsTrainingRegistrationForm />}
          />
          <Route
            path={`${match.path}`}
            render={() => <DigitalSkillsTrainingHome />}
          />
        </Switch>
      </Desktop>
    </>
  );
};

export default DigitalSkillsTraining;
